// Pure date helpers for the "Later" deadline picker.
// Dates are returned at start-of-day so a ticket resurfaces from the start of
// the chosen day onward.

export const PRESET_KEYS = ['tomorrow', 'in3days', 'nextWeek', 'in1month'];

export function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

export function presetDate(preset, baseDate = new Date()) {
    const d = startOfDay(baseDate);
    switch (preset) {
    case 'tomorrow':
        d.setDate(d.getDate() + 1);
        return d;
    case 'in3days':
        d.setDate(d.getDate() + 3);
        return d;
    case 'nextWeek':
        d.setDate(d.getDate() + 7);
        return d;
    case 'in1month':
        d.setMonth(d.getMonth() + 1);
        return d;
    default:
        return null;
    }
}
